module.exports = __webpack_public_path__ + "static/media/Seamless Shortcuts Customization & Blockstream Experience for AutoCAD for Mac.fc4300bf.png";